import { useState } from 'react'

import { getCleanConversion } from '../../../main/blacklistHelpers'
import ConfirmationDialog from '../ConfirmationDialog/index'
import LoadingIndicator from '../LoadingIndicator'
import BlacklistContext from './BlackListContext'
import styles from './BlackListDialog.module.scss'
import BehaviorAndScope from './Steps/BehaviorAndScope/index'
import Confirmation from './Steps/Confirmation/index'
import Details from './Steps/Details/index'
import useBlacklistDetails from './useBlacklistDetails'

const BlacklistDialog = ({
  conversion: dC,
  handleHideDialog,
  handleSubmit,
  isLoading
}) => {
  const blacklistDetails = useBlacklistDetails()
  const conversion = getCleanConversion(dC)

  const { exclusions, values } = blacklistDetails

  const [step, setStep] = useState(1)

  const titles = [
    'Select the details to exclude',
    'Select behavior and scope',
    `Do you want to exclude ${values.length > 1 ? 'these' : 'this'}?`,
    values.length > 1 ? 'Yes, exclude all' : 'Yes, exclude this'
  ]

  const cta = ['Continue', 'Continue', `Yes, exclude ${values.length > 1 ? 'all' : ''}`]

  function handleConfirm() {
    if (step < 3) {
      setStep(step + 1)
    }

    if (step === 3) {
      handleSubmit(exclusions, conversion.convertedSubscriberHotelBookingId)
    }
  }

  function handleBack() {
    if (step > 1) {
      setStep(step - 1)
    }
  }

  function getIsButtonDisabled() {
    const numberOfExceptions = Object.keys(values).length

    if (step === 1 && numberOfExceptions) {
      return false
    }

    if (step === 2 && exclusions.filter(o => !o.behavior || !o.scope).length === 0) {
      return false
    }

    if (step === 3) {
      return false
    }

    return true
  }

  return (
    <BlacklistContext.Provider value={{ ...blacklistDetails, conversion }}>
      <ConfirmationDialog
        title={titles[step - 1]}
        theme="blacklist"
        onConfirm={handleConfirm}
        isButtonDisabled={getIsButtonDisabled()}
        positiveMessage={cta[step - 1]}
        hasDangerousAction={step === 3 && true}
        onReject={handleBack}
        negativeMessage={step > 1 && 'Back'}
        onClose={handleHideDialog}
        maxWidth={900}
        contentPadding={20}
      >
        <div className={styles.container}>
          {isLoading ? (
            <LoadingIndicator />
          ) : (
            <>
              {step === 1 && <Details />}
              {step === 2 && <BehaviorAndScope />}
              {step === 3 && <Confirmation />}
            </>
          )}
        </div>
      </ConfirmationDialog>
    </BlacklistContext.Provider>
  )
}

export default BlacklistDialog
